export default __webpack_public_path__ + "static/realWorldImg2-bb092ca662cce3e813a829b4d3e24dd3.png";